"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
const cachefunction_1 = require("./cachefunction");
const bind_1 = require("./bind");
/**Subscribe una función para que sea llamada cada vez que se invalida el resource. Maneja correctamente las dependencias circulares eliminando los ciclos infinitos en las mismas */
function addOnInvalidateHandler(resource, handler) {
    resource.onInvalidateHandlers = resource.onInvalidateHandlers || [];
    resource.onInvalidateHandlers.push(handler);
}
exports.addOnInvalidateHandler = addOnInvalidateHandler;
/**Arreglo global de las llamadas realizadas a los handlers de invalidación, se utiliza para prevenir que las dependencias circulares ocasionen ciclos infinitos
 * cuando se invalida un resource
 */
let invalidateResourceHandlerStack = [];
/**
 * Invalida un resource, limpiando todos los caches memoizados. Esto simplemente llama a la función @see invalidate() de cada uno de los miembros del resource, y a todos los @see onInvalidateHandlers que estan
 * definidos para el mismo
 * @param resource Resource que se quiere invalidar
 */
async function invalidateResource(resource) {
    /**Todos los posibles handlers de invalidacion, sin contar los de onInvalidateHandlers */
    let invalidates = keautils_1.enumObject(resource).map(x => ({
        value: x.value,
        isFunc: typeof (x.value) == "function"
    }))
        .map(x => ({
        isFunc: x.isFunc,
        invalidate: x.value && x.value.invalidate
    }));
    /**Llama de manera paralela una lista de handlers de invalidación */
    function invalidateAll(items) {
        const promises = items.map(x => x());
        if (keautils_1.any(promises, x => keautils_1.isPromiseLike(x))) {
            return Promise.all(promises);
        }
    }
    //Primero invalidamos las funciones:
    {
        const prom = invalidateAll(invalidates.filter(x => x.isFunc && x.invalidate).map(x => x.invalidate));
        if (keautils_1.isPromiseLike(prom)) {
            await prom;
        }
    }
    //Luego invalidamos todo lo demas, este orden se sigue porque generalmente las funciones son fuente de datos de los observables
    {
        const prom = invalidateAll(invalidates.filter(x => !x.isFunc && x.invalidate).map(x => x.invalidate));
        if (keautils_1.isPromiseLike(prom)) {
            await prom;
        }
    }
    //Al final invalidamos los handlers de invalidación
    if (resource.onInvalidateHandlers) {
        {
            //Solo invalidamos los que no estan en el stack, evitando el ciclo infinito
            const toCall = resource.onInvalidateHandlers.filter(x => !keautils_1.contains(keautils_1.flatten(invalidateResourceHandlerStack), x));
            //Agregamos los que se van a llamar al stack
            invalidateResourceHandlerStack.push(toCall);
            let prom;
            try {
                const prom = invalidateAll(toCall);
            }
            finally {
                prom = undefined;
                //Sacamos del stack el ultimo
                invalidateResourceHandlerStack.pop();
            }
            if (keautils_1.isPromiseLike(prom)) {
                await prom;
            }
        }
    }
}
exports.invalidateResource = invalidateResource;
/**
 * Memoiza todas las funciones de un resource. Cada funcion tiene un metodo invalidate el cual invalida el cache memoizado
 * @param resource Resource que se quiere memoizar
 * @param memoize Indica cuales funciones se van a memoizar.  Memoize todas las funciones de consulta siempre y cuando no devuelvan resultados grandes ya que la memoización almacena los ultimos 16 resultados de la función y esto podria ocasionar que consuman mucha memoria. Aqui tambien puede indicar el tamaño del cache si es que especifica un numero en lugar de un booleano
 * Si se especifica undefined se conserva el memoize original
 * @param invalidates Indica las funciones que al ser llamadas deben de invalidar el cache. Por ejemplo las funciones que agreguen, editen o borren registros.
 */
function cacheResource(resource, memoize, invalidates) {
    //Propiedades que se deben de ignorar
    const extras = ["onInvalidateHandlers", "bindedResource", "createObservable"];
    const moize = keautils_1.mapObject(resource, (value, key) => {
        const memoKey = memoize && memoize[key];
        const defaultCacheSize = 16;
        const cacheSize = memoKey == null ? undefined : (memoKey == true ? defaultCacheSize : (memoKey || 0));
        if (typeof value == "function" && !keautils_1.contains(extras, key))
            return cachefunction_1.cacheResourceFunction(key, keautils_1.unbindFunction(value) || value, cacheSize, invalidates && invalidates[key]);
        else {
            if ((cacheSize && cacheSize > 0) || (invalidates && invalidates[key])) {
                throw new Error(`No se puede memoizar o marcar como invalidable la propiedad ${key} ya que no es una función `);
            }
            return value;
        }
    });
    return bind_1.bindResource(moize);
}
exports.cacheResource = cacheResource;
//# sourceMappingURL=cache.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/cache/cache.js
// module id = 303
// module chunks = 0